
            const data = {"name":"feather/globe","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<circle pid=\"0\" cx=\"12\" cy=\"12\" r=\"10\"/><path pid=\"1\" d=\"M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z\"/>","originalColors":[],"stopColors":[]}}
        
                module.exports = data
                